export default {
  BASE: 1,
  AIRSOFT: 2,
  ESPORTS: 3
};